export default __webpack_public_path__ + "img/square_0.d69150860f25b37fcc06b67228fa1dde.jpg";